import { Wrapper } from './InformationBanner.styles';

import { Icon } from '@/components/Icon';

interface InformationBannerProps {
  text: string;
}
export const InformationBanner: React.FC<InformationBannerProps> = ({ text }) => {
  return (
    <Wrapper>
      <Icon i="InformationFilled" size={20} color="purple6" />
      <span>{text}</span>
    </Wrapper>
  );
};
